// slotsApi.js
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


export async function fetchSlots() {
    const response = await fetch(`${API_BASE_URL}/slots`);
    if (!response.ok) {
        throw new Error('Ошибка при получении слотов');
    }
    return await response.json();
}

export async function updateAnketa(anketId, intention, fullName) {
    const response = await fetch(`${API_BASE_URL}/updateanketa`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ anketId, intention, fullName }),
    });

    if (!response.ok) {
        throw new Error('Ошибка при обновлении анкеты');
    }

    return await response.json();
}

export async function uploadPhoto(formData) {
    const response = await fetch(`${API_BASE_URL}/uploadphoto`, {
        method: 'POST',
        body: formData,
    });

    if (!response.ok) {
        throw new Error('Ошибка при загрузке фото');
    }

    return await response.text(); // допустим сервер возвращает обновлённую строку `photo1.jpg|photo2.jpg`
}

export async function deletePhoto(anketaId, photoIndex) {
    const response = await fetch(`${API_BASE_URL}/deletephoto`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ anketaId, photoIndex }),
    });

    if (!response.ok) {
        throw new Error('Ошибка при удалении фото');
    }

    return await response.text(); // сервер возвращает обновлённую строку "photo1.jpg|photo2.jpg"
}




export async function cancelAnketa(anketId) {
    const response = await fetch(`${API_BASE_URL}/anket/${anketId}`, {
        method: 'DELETE',
    });

    if (!response.ok) {
        throw new Error('Ошибка при отмене анкеты');
    }

    return await response.json();
}

export async function fetchBookingPeriod() {
    const response = await fetch(`${API_BASE_URL}/booking-period`);
    if (!response.ok) {
        throw new Error('Ошибка при получении периода записи');
    }
    return await response.json();
}

export async function bookSlot(slotId, email) {
    console.log('bookSlot', slotId, email)
    const res = await fetch(`${API_BASE_URL}/bookslot`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ slotId, email }),
    });

    if (!res.ok) {
        const err = await res.json();
        throw new Error(err.error || 'Ошибка при бронировании');
    }
    return await res.json();
}

export async function fetchMySlots(email) {
    console.log('fetchMySlots', email);
    const res = await fetch(`${API_BASE_URL}/myslots`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
    });

    if (!res.ok) {
        const err = await res.json();
        throw new Error(err.error || 'Ошибка при получении моих слотов');
    }

    const res_json = await res.json();
    console.log('fetchMySlots res', res_json);
    return res_json;
}

export async function saveAnketa(anketId, formData) {
  // formData — это объект FormData с файлами и полями
  const res = await fetch(`${API_BASE_URL}/saveanketa`, {
    method: 'POST',
    body: formData, // browser автоматически выставит заголовок Content-Type с boundary
  });

  if (!res.ok) {
    const err = await res.json();
    throw new Error(err.error || 'Ошибка при сохранении анкеты');
  }

  return await res.json();
}

export async function saveFeedback(anketId, feedback) {
    const res = await fetch(`${API_BASE_URL}/savefeedback`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ anketId, feedback }),
    });

    if (!res.ok) {
        const err = await res.json();
        throw new Error(err.error || 'Ошибка при сохранении отзыва');
    }

    return await res.json();
}


